module.exports = __webpack_public_path__ + "img/b3.cb88fc76.png";